import Base from './Base';
import moment from 'moment-timezone';
import User from './User';

export default class Invite extends Base {
    constructor(item) {
        super(item);

        this.loading = false;

        this.user = item.user ? new User(item.user) : new User({});
    }

    get color() {
        const palette = [
            '#6372A5',
            '#1D95F2',
            '#10D0AD',
            '#E13466',
            '#FFC422',
            '#FF9423',
            '#A233E1',
        ];

        return palette[this.id % palette.length];
    }

    handleDate(tz) {
        if (tz) {
            return moment.utc(this.created_at).tz(tz).format('MMMM D, YYYY');
        }

        return moment.utc(this.created_at).local().format('MMMM D, YYYY');
    }

    createAtFormated(tz) {
        if (this.hasRequestDate) {
            return `Requested ${this.handleDate(tz)} (${this.integrationName})`;
        }

        return `Sent ${this.handleDate(tz)}`;
    }

    get integrationName() {
        switch (this.integration) {
        case 'hubspot': return 'HubSpot';
        default: return '';
        }
    }

    get hasRequestDate() {
        return !!this.request_date;
    }

    get fullName() {
        if (this.hasRequestDate) {
            return `${this.first_name} ${this.last_name}`;
        }

        return this.user.full_name;
    }

    get userInfo() {
        if (this.hasRequestDate) {
            return {
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                photo_url: '',
                color: this.color,
            };
        }

        return {
            ...this.user,
            color: this.color,
        };
    }

    get isOwnerRole() {
        return this.user.isOwnerRole;
    }

    get isViewOnlyRole() {
        return this.user.isViewOnlyRole;
    }

    get isMemberRole() {
        return this.user.isMemberRole;
    }

    get isManagerRole() {
        return this.user.isManagerRole;
    }

    get isAdminRole() {
        return this.user.isAdminRole;
    }

    get roleLabel() {
        return this.user.roleLabel;
    }
}
